import { createContext } from 'react';
// Create Context
const AuthContext = createContext({});
export const AuthProvider = AuthContext.Provider;
export const AuthConsumer = AuthContext.Consumer;

export default AuthContext;
